import { applicationContext } from "core/utils";
import { BaseEditViewStore } from "core/stores";
import { ConfirmingReportFileUploadForm } from "application/confirming-report/forms";
import { ConfirmingReportService } from "application/confirming-report/services";
import { action } from "mobx";

@applicationContext
class ConfirmingReportFileUploadViewStore extends BaseEditViewStore {    
    constructor(rootStore) {
        const confirmingReportService = new ConfirmingReportService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: "confirming-report-file-upload",
            Form: ConfirmingReportFileUploadForm,
            actions: () => {
                return {
                    uploadReport: async () => {
                        const file = this.form.fields.get("file").files[0];

                        await confirmingReportService.uploadReport({ file });
                    }   
                };
            },
            FormClass: ConfirmingReportFileUploadForm
        });

        this.setTitle();
    }

    @action.bound
    async setTitle() {
		this.rootStore.viewStore.setNavigationOptions({
			hideColon: true
		});
	}

    @action.bound
    async createResource(resource) {
        if (!this.actions.uploadReport)
            return;
            
        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore)
                this.translationStore.applyMetadata(resource);

            await this.actions.uploadReport(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success("CONFIRMING_REPORT.REPORT_UPLOAD.SUCCESS"));

        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(err && err.data ? err.data : "CONFIRMING_REPORT.REPORT_UPLOAD.ERROR");
        }
    }
}

export default ConfirmingReportFileUploadViewStore;